<script>
    import { inspectionWaitingStore, appStateStore, fetchProcessInspectionWaitingData } from "./store.js";
    import { onMount } from "svelte";
    import { Preferences } from "@capacitor/preferences";
    import toast from "svelte-french-toast";
    import { fade, scale } from "svelte/transition";

    let selectedItem = null;
    let session_bplc_code = "01";

    onMount(async () => {
        const { value } = await Preferences.get({ key: "retechInfo" });
        if (value) {
            const userData = JSON.parse(value);
            session_bplc_code = userData.bplc_code || "01";
        }

        if ($inspectionWaitingStore.list.length === 0) {
            getData();
        }
    });

    async function getData() {
        await fetchProcessInspectionWaitingData(session_bplc_code);
    }

    function handleSelect() {
        if (!selectedItem) {
            return toast.error("항목을 선택해주세요.");
        }
        appStateStore.set({
            currentView: "detail",
            selectedId: "new",
            waitingData: selectedItem,
        });
        closeModal();
    }

    function closeModal() {
        inspectionWaitingStore.update((s) => ({ ...s, modalOpen: false }));
    }

    function rowClick(item) {
        selectedItem = item;
    }
</script>

<div
    class="modal-overlay"
    transition:fade={{ duration: 150 }}
    on:click|self={closeModal}
>
    <div class="modal-window" transition:scale={{ duration: 200, start: 0.95 }}>
        <header class="modal-header">
            <div class="title-area">
                <span class="icon">🔍</span>
                <h2>신규 - 공정검사 대기 정보</h2>
            </div>
            <div class="action-buttons">
                <button class="m-btn btn-search" on:click={getData}>
                    조회
                </button>
                <button class="m-btn btn-select" on:click={handleSelect}>
                    선택
                </button>
                <button class="m-btn btn-cancel" on:click={closeModal}>
                    취소
                </button>
                <button class="m-btn btn-close" on:click={closeModal}>
                    닫기
                </button>
            </div>
        </header>

        <div class="modal-body">
            <!-- Search Area -->
            <section class="search-section">
                <div class="section-label">조회조건</div>
                <div class="search-container">
                    <div class="search-grid">
                        <div class="field-group">
                            <label>생산계획번호</label>
                            <div class="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="계획번호 입력"
                                    bind:value={$inspectionWaitingStore.search.plan_no}
                                />
                            </div>
                        </div>

                        <div class="field-group">
                            <label>제조번호</label>
                            <div class="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="제조번호 입력"
                                    bind:value={$inspectionWaitingStore.search.mnfctur_order_no}
                                />
                            </div>
                        </div>

                        <div class="field-group span-2">
                            <label>품목</label>
                            <div class="double-input-wrapper">
                                <input
                                    type="text"
                                    class="flex-input"
                                    placeholder="코드"
                                    bind:value={$inspectionWaitingStore.search.item_code}
                                />
                                <span class="range-sep invisible">~</span>
                                <input
                                    type="text"
                                    class="flex-input"
                                    placeholder="품목명 입력"
                                    bind:value={$inspectionWaitingStore.search.item_nm}
                                />
                            </div>
                        </div>

                        <div class="field-group span-2">
                            <label>작업시작일</label>
                            <div class="date-range-wrapper">
                                <input
                                    type="date"
                                    bind:value={$inspectionWaitingStore.search.startDate}
                                />
                                <span class="range-sep">~</span>
                                <input
                                    type="date"
                                    bind:value={$inspectionWaitingStore.search.endDate}
                                />
                            </div>
                        </div>

                        <div class="field-group">
                            <label>검사구분</label>
                            <div class="input-wrapper">
                                <select bind:value={$inspectionWaitingStore.search.inspct_at}>
                                    <option>전체</option>
                                    <option value="N">신규검사</option>
                                    <option value="R">재검사</option>
                                </select>
                            </div>
                        </div>

                        <div class="field-group">
                            <label>LOT NO</label>
                            <div class="input-wrapper">
                                <input
                                    type="text"
                                    placeholder="LOT 번호"
                                    bind:value={$inspectionWaitingStore.search.lot_no}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Table Area -->
            <section class="list-section">
                <div class="section-label">내역</div>
                <div class="table-container">
                    <table class="waiting-table">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>생산계획번호</th>
                                <th>제조오더번호</th>
                                <th>품목코드</th>
                                <th>품목명</th>
                                <th>규격</th>
                                <th>검사구분</th>
                                <th>LOT NO</th>
                                <th>ERP LOT NO</th>
                                <th>창고</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#if $inspectionWaitingStore.list.length === 0}
                                <tr>
                                    <td colspan="10" class="empty">
                                        데이터가 없습니다.
                                    </td>
                                </tr>
                            {:else}
                                {#each $inspectionWaitingStore.list as item, i (item.id)}
                                    <tr
                                        class:active={selectedItem && selectedItem.id === item.id}
                                        on:click={() => rowClick(item)}
                                    >
                                        <td class="center">{i + 1}</td>
                                        <td>{item.plan_no}</td>
                                        <td>{item.mnfctur_order_no}</td>
                                        <td>{item.item_code}</td>
                                        <td>{item.item_nm}</td>
                                        <td>{item.stndrd}</td>
                                        <td class="center">
                                            <span class="badge {item.inspct_at === 'R' ? 're' : 'new'}">
                                                {item.inspct_at === "R" ? "재검사" : "신규검사"}
                                            </span>
                                        </td>
                                        <td class="bold">{item.lot_no}</td>
                                        <td>{item.wrhousng_lot_no}</td>
                                        <td>{item.wrhous_code}</td>
                                    </tr>
                                {/each}
                            {/if}
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
        <footer class="modal-footer">
            조회 : {$inspectionWaitingStore.list.length} 건 | 조회가 완료되었습니다.
        </footer>
    </div>
</div>

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(15, 23, 42, 0.6);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2000;
        padding: 20px;
    }
    .modal-window {
        background: white;
        width: 100%;
        max-width: 1200px;
        height: 85vh;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        border: 1px solid #e2e8f0;
    }
    .modal-header {
        background: #f8fafc;
        padding: 12px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #e2e8f0;
    }
    .title-area {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .title-area h2 {
        font-size: 1.05rem;
        font-weight: 800;
        color: #1e293b;
        margin: 0;
    }
    .icon {
        font-size: 1.2rem;
    }
    .action-buttons {
        display: flex;
        gap: 8px;
    }
    .m-btn {
        padding: 6px 16px;
        font-size: 0.85rem;
        font-weight: 700;
        border: 1px solid #e2e8f0;
        background: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        border-radius: 8px;
        transition: all 0.2s;
        color: #475569;
    }
    .m-btn:hover {
        background: #f1f5f9;
        transform: translateY(-1px);
    }
    .btn-search {
        color: #2563eb;
        border-color: #bfdbfe;
    }
    .btn-select {
        background: #3b82f6;
        color: white;
        border-color: #3b82f6;
    }
    .btn-select:hover {
        background: #2563eb;
    }
    .btn-cancel {
        color: #ef4444;
        border-color: #fecaca;
    }
    .modal-body {
        flex: 1;
        padding: 20px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 20px;
        background: #f8fafc;
    }
    .section-label {
        font-size: 0.9rem;
        font-weight: 800;
        color: #f97316;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 6px;
    }
    .section-label::before {
        content: "";
        display: inline-block;
        width: 10px;
        height: 10px;
        background: #f97316;
        border-radius: 50%;
    }
    .search-section {
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        padding: 15px 20px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }
    .search-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px 20px;
    }
    .field-group {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    .field-group.span-2 {
        grid-column: span 2;
    }
    .field-group label {
        font-size: 0.85rem;
        font-weight: 700;
        color: #475569;
        white-space: nowrap;
        width: 85px;
        flex-shrink: 0;
    }
    .input-wrapper {
        flex: 1;
        display: flex;
    }
    .input-wrapper input, .input-wrapper select {
        width: 100%;
        height: 36px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 14px;
        font-size: 0.85rem;
        transition: all 0.2s;
        background: #f8fafc;
    }
    .double-input-wrapper {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .flex-input {
        flex: 1;
        height: 36px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 14px;
        font-size: 0.85rem;
        background: #f8fafc;
        transition: all 0.2s;
        width: 0;
    }
    .date-range-wrapper {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .date-range-wrapper input {
        flex: 1;
        height: 36px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 12px;
        font-size: 0.85rem;
        background: #f8fafc;
    }
    .range-sep {
        color: #94a3b8;
        font-weight: 700;
    }
    .list-section {
        flex: 1;
        display: flex;
        flex-direction: column;
        background: white;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        overflow: hidden;
        min-height: 300px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }
    .list-section .section-label {
        padding: 12px 20px;
        margin: 0;
        background: #f8fafc;
        border-bottom: 1px solid #e2e8f0;
    }
    .table-container {
        flex: 1;
        overflow: auto;
    }
    .waiting-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 0.85rem;
    }
    .waiting-table th {
        background: #f1f5f9;
        padding: 10px 12px;
        border-bottom: 2px solid #e2e8f0;
        position: sticky;
        top: 0;
        font-weight: 700;
        color: #475569;
        text-align: left;
        z-index: 10;
        white-space: nowrap;
    }
    .waiting-table td {
        padding: 12px;
        border-bottom: 1px solid #f1f5f9;
        white-space: nowrap;
        color: #334155;
    }
    .waiting-table tr:hover {
        background: #f8fafc;
        cursor: pointer;
    }
    .waiting-table tr.active {
        background: #eff6ff;
    }
    .center {
        text-align: center;
    }
    .bold {
        font-weight: 700;
        color: #1e293b;
    }
    .empty {
        padding: 60px;
        text-align: center;
        color: #94a3b8;
        font-weight: 600;
    }
    .badge {
        padding: 2px 10px;
        border-radius: 4px;
        font-size: 0.75rem;
        font-weight: 800;
    }
    .new {
        background: #e0f2fe;
        color: #0369a1;
    }
    .re {
        background: #fef3c7;
        color: #b45309;
    }
    .modal-footer {
        background: #1e293b;
        color: #94a3b8;
        padding: 8px 20px;
        font-size: 0.75rem;
        font-weight: 700;
    }
</style>
